function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.34079 11.3876C1.13181 11.1787 0.966045 10.9306 0.852948 10.6576C0.739851 10.3846 0.681641 10.092 0.681641 9.79648C0.681641 9.50097 0.739851 9.20836 0.852948 8.93535C0.966045 8.66234 1.13181 8.41429 1.34079 8.20535L6.64404 2.90135L13.0085 9.26585L10.5763 11.6974H14C14.1989 11.6974 14.3897 11.7764 14.5304 11.917C14.671 12.0577 14.75 12.2484 14.75 12.4474C14.75 12.6463 14.671 12.837 14.5304 12.9777C14.3897 13.1183 14.1989 13.1974 14 13.1974H4.08353C3.48695 13.1974 2.91477 12.9606 2.49279 12.5389L1.34003 11.3869L1.34079 11.3876ZM14.0683 8.20535L15.1295 7.1441C15.5513 6.72216 15.7883 6.14997 15.7883 5.55335C15.7883 4.95673 15.5513 4.38454 15.1295 3.9626L11.9473 0.780352C11.5253 0.358542 10.9532 0.121582 10.3565 0.121582C9.75992 0.121582 9.18772 0.358542 8.76579 0.780352L7.70529 1.84085L14.0683 8.20535Z",
  fill: "white"
});

function SvgImageViewerErase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageViewerErase);
export default __webpack_public_path__ + "static/media/image-viewer-erase.7ddf4314.svg";
export { ForwardRef as ReactComponent };